import { useQuery } from '@tanstack/react-query';
import { kanbanService } from '@/api/services/kanban.service';
import type { KanbanBoard } from '@/api/types/kanban.types';

/**
 * Hook for fetching Kanban board data
 * @param slug - Board slug (e.g., 'razvoj', 'biznisoft_mobile')
 */
export const useKanbanBoard = (slug: string) => {
  return useQuery<KanbanBoard, Error>({
    queryKey: ['kanban', 'board', slug],
    queryFn: () => kanbanService.getBoardBySlug(slug),
    enabled: !!slug,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: true,
  });
};
